import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/hooks';
import { Modal, Button, Form } from 'react-bootstrap';
import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import { renewKey, apiKeyState, resetCreatedKey } from '../apiKeySlice';


interface Props {
    children?: React.ReactNode;
    item?: any;
}

const RotateKeyModal = (props: Props) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const dispatch = useAppDispatch();

    const { createdKey } = useAppSelector(apiKeyState);


    useEffect(() => {

        if (createdKey.isSuccess) {
            handleClose();
            dispatch(resetCreatedKey());
        }
    }, [createdKey, dispatch]);

    const confirmAction = () => {
        const userId = props?.item.id;
        if (userId) {
            dispatch(renewKey({ id: userId, tokenDuration: "100y" }))
        }
    };

    return (
        <>
            <div onClick={handleShow}>{props?.children}</div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Rotate API Key</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {createdKey.isLoading && < SmashSpinner />}
                    {!createdKey.isLoading &&
                        <div>
                            Are you sure to renew the token associated to the following API key ?
                            <p className="text-center">
                                <code>{props?.item.username}</code>
                            </p>
                            <p className="text-danger">
                                <strong>This will invalidate the previous associated token</strong>
                            </p>
                            {/* <Form.Group className="mb-3" controlId="tokenDuration">
                                <Form.Label>ApiKey Duration</Form.Label>
                                <Form.Control
                                    type="number" placeholder="ApiKey Duration"
                                    value={tokenDuration}
                                    onChange={tokenDurationChangeHandler}
                                    onBlur={tokenDurationBlurHandler}
                                />
                            </Form.Group> */}

                        </div>}
                </Modal.Body>
                {!createdKey.isLoading && <Modal.Footer>
                    <Button onClick={handleClose} variant='light'>No</Button>
                    <Button onClick={confirmAction}>Yes</Button>
                </Modal.Footer>}
            </Modal>
        </>
    )
}

export default RotateKeyModal